import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Capabilities from "@/pages/Capabilities";
import Contact from "@/pages/Contact";
import Pay from "@/pages/Pay";
import PaySuccess from "@/pages/PaySuccess";
import PayCancel from "@/pages/PayCancel";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const finePointer = window.matchMedia("(pointer: fine)").matches;
        if (reduce || !finePointer) return undefined;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:bg-slate-100 focus:px-4 focus:py-2 focus:font-mono focus:text-xs focus:uppercase focus:tracking-widest focus:text-slate-900"
            >
                Skip to content
            </a>
            <Navbar />
            <main id="main-content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/insights/:slug" element={<InsightArticle />} />
                    <Route path="/capabilities" element={<Capabilities />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pay" element={<Pay />} />
                    <Route path="/pay/success" element={<PaySuccess />} />
                    <Route path="/pay/cancel" element={<PayCancel />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </main>
            <Footer />
        </BrowserRouter>
    );
}

export default App;
